import { render } from "./RegularNotification.vue?vue&type=template&id=e6419fcc&scoped=true&ts=true"
import script from "./RegularNotification.vue?vue&type=script&lang=ts"
export * from "./RegularNotification.vue?vue&type=script&lang=ts"

import "./RegularNotification.scss?vue&type=style&index=0&id=e6419fcc&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./RegularNotification.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6419fcc"]])

export default __exports__